export default "__VITE_ASSET__BF$5vdla__"